import { DataBean } from "../DataBean";

export class DocumentAffiliate extends DataBean {


    public async getDocumentAffiliateCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getDocumentAffiliateCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}